// extracted by mini-css-extract-plugin
export default {"loadingContainer":"detail_loadingContainer__FC0k7"};